import React, { useState } from 'react';

const ReplyForm = ({ onSendReply, isSubmitting }) => {
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!message.trim()) return;
    
    onSendReply(message);
    setMessage('');
  };

  return (
    <div className="border-t border-base-200 pt-4">
      <h3 className="font-medium mb-2 text-base-content">Répondre</h3>
      <form onSubmit={handleSubmit}>
        <textarea
          className="textarea textarea-bordered w-full h-32 bg-base-100 text-base-content"
          placeholder="Saisissez votre réponse..."
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          disabled={isSubmitting}
          required
        />
        <div className="flex justify-end mt-2">
          <button
            type="submit"
            className="btn btn-primary"
            disabled={isSubmitting || !message.trim()}
          >
            {isSubmitting ? (
              <>
                <span className="loading loading-spinner loading-xs mr-2"></span>
                Envoi...
              </>
            ) : (
              'Envoyer la réponse'
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ReplyForm;